import { render, staticRenderFns } from "./MediaPage.vue?vue&type=template&id=303b54c4&"
import script from "./MediaPage.vue?vue&type=script&lang=js&"
export * from "./MediaPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports